// Resources
import API from "../helpers/API"

/**
 * Componente funcional para manipulacão dos dados do pagamento online
 */
const PaymentsController = {
  createPayment(order, saveCard, customer, paymentType, newRequest) {
    return API.request("/v1/payments/create", { integration: "mercadopago", order, saveCard, customer, paymentType, resend: newRequest }, "POST")
  },

  getPendingPayments() {
    return API.request(`/v1/payments/pending/website`, {}, "GET")
  },

  getPaidPayments(customerUid) {
    return API.request(`/v1/payments/paid/${customerUid}`, {}, "GET")
  },

  getPaymentInfo(paymentId) {
    return API.request(`/v1/payments/info`, { paymentId }, "GET")
  },

  getHash(data) {
    return API.request("/v1/payments/hash", data, "GET")
  },

  getRecentPendingPayments() {
    return API.request(`/v1/payments/recent/pending`, {}, "GET")
  },

  getOrderByPaymentRef(paymentId) {
    return API.request(`/v1/payments/order/${paymentId}`, {}, "GET")
  },
}

export default PaymentsController
